module.exports = __webpack_public_path__ + "style/img/Group 1952.5d6d2223.png";